var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4091 13.6363V12.2727C12.4091 11.5494 12.1218 10.8557 11.6103 10.3442C11.0988 9.83275 10.4051 9.54541 9.68182 9.54541H4.22727C3.50396 9.54541 2.81026 9.83275 2.2988 10.3442C1.78734 10.8557 1.5 11.5494 1.5 12.2727V13.6363",
    stroke: "#A5A5A5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95469 6.81832C8.46092 6.81832 9.68196 5.59727 9.68196 4.09104C9.68196 2.58481 8.46092 1.36377 6.95469 1.36377C5.44846 1.36377 4.22742 2.58481 4.22742 4.09104C4.22742 5.59727 5.44846 6.81832 6.95469 6.81832Z",
    stroke: "#A5A5A5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 13.6365V12.2728C16.4996 11.6686 16.2984 11.0816 15.9282 10.604C15.558 10.1264 15.0397 9.78528 14.4546 9.63421M11.7273 1.45239C12.3139 1.6026 12.8339 1.94378 13.2052 2.42215C13.5765 2.90052 13.7781 3.48887 13.7781 4.09444C13.7781 4.70001 13.5765 5.28836 13.2052 5.76673C12.8339 6.2451 12.3139 6.58628 11.7273 6.73648",
    stroke: "#A5A5A5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/icon-user.5e2cec573165260ad20cfe2fd87b0189.svg";
export { ForwardRef as ReactComponent };